import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/img_question.png'


const _withScopeId = n => (_pushScopeId("data-v-7efa7c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "play-well-wrapper paddingTop40" }
const _hoisted_2 = { class: "play-well" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center" }, "玩转ERP", -1))
const _hoisted_4 = { class: "example-play row-flex items-start" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "example-play-right" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "content" }

import { palyWellList } from "../../assets/homeData"

export default /*#__PURE__*/_defineComponent({
  __name: 'PlayWell',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(palyWellList), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.name,
          class: "example-play-wrapper marginBot20"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.content), 1)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})